import React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  className?: string;
}

export default function SidebarArrowUpDownIcon({ size = 16, className, ...props }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M12.8891 10.3842L8.95497 14.3183C8.49036 14.7829 7.73009 14.7829 7.26548 14.3183L3.33138 10.3842"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8891 5.61581L8.95497 1.68171C8.49036 1.2171 7.73009 1.2171 7.26548 1.68171L3.33138 5.61581"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
